import merge from 'lodash/merge';
import FormModule from "./module.svelte";
import ServiceProvider from "./providers/service.provider";
import DataProvider from "./providers/data.provider";
import CreateService from "./services/create.service";
class NewsletterModule {
    constructor(options) {
        this.options = options;
        this._setup();
    }
    // MOUNT
    _setup() {
        this.prepareOptions();
        this.dataProvider = new DataProvider(this.options);
        this.serviceProvider = new ServiceProvider(new CreateService);
        this._initApp();
    }
    // CREATE INSTANCE
    _initApp() {
        new FormModule({
            target: this.targetElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
    }
    // GETTERS
    get targetElement() {
        return this.options.el;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            el: null,
            textAbove: null,
            gdprText: null,
            gdprLinkUrl: null,
            gdprLinkText: null,
            submitText: null,
            submitProcessing: null,
            errEmailUsed: null,
            msgSuccess: null,
        }, this.options);
    }
}
const element = document.getElementById('app-newsletter');
if (element) {
    const textAbove = element.getAttribute('data-text-above') || 'Odebírejte kulturní newsletter';
    const gdprText = element.getAttribute('data-gdpr-text') || 'Souhlasím se';
    const gdprLinkUrl = element.getAttribute('data-gdpr-link-url') || '';
    const gdprLinkText = element.getAttribute('data-gdpr-link-text') || 'zpracováním osobních údajů';
    const submitText = element.getAttribute('data-submit-text') || 'Odeslat';
    const submitProcessing = element.getAttribute('data-submit-processing') || 'Odesílám...';
    const errEmailUsed = element.getAttribute('data-err-email-used') || 'E-mailová adresa již byla registrovaná pro odběr novinek z webu Kultura Brno. Zkontrolujte svou e-mailovou schránku.';
    const msgSuccess = element.getAttribute('data-msg-success') || 'Odeslání e-mailu proběhlo úspěšně. Proces registrace je nutné dokončit prostřednictvím zadané e-mailové adresy a potvrzením přiloženého odkazu.';
    new NewsletterModule({
        el: element,
        textAbove,
        gdprText,
        gdprLinkUrl,
        gdprLinkText,
        submitText,
        submitProcessing,
        errEmailUsed,
        msgSuccess,
    });
}
